// themedLazy = React.lazy + theme antd tải song song (antd không nằm trong JS chính)
import { lazy } from "react";
import themedLazy from "./utils/themedLazy";

// Public pages
const NotFound           = lazy(() => import("./components/NotFound"));
// Trang chủ không dùng antd (đã thay Pagination/notification) → không tải theme antd, hiện nhanh hơn.
// Thêm component antd vào trang chủ thì đổi lại thành themedLazy.
const HomePage           = lazy(() => import("./pages/HomePage"));
const LoginPage          = themedLazy(() => import("./pages/LoginPage"));
const RegisterPage       = themedLazy(() => import("./pages/RegisterPage"));
const ProductDetailPage  = lazy(() => import("./pages/ProductDetailPage")); // không dùng antd ở lần tải đầu (Drawer/đánh giá… tải khi cần)
const CartPage           = themedLazy(() => import("./pages/CartPage"));
const SearchPage         = lazy(() => import("./pages/SearchPage")); // không dùng antd ở lần tải đầu (Drawer/đánh giá… tải khi cần)
const ProfilePage        = themedLazy(() => import("./pages/ProfilePage"));
const PaymentPage        = themedLazy(() => import("./pages/PaymentPage"));
const OrderPage          = themedLazy(() => import("./pages/OrderPage"));
const NewsPage           = themedLazy(() => import("./pages/NewsPage"));
const PostPage           = themedLazy(() => import("./pages/PostPage"));
const SubjectPage        = themedLazy(() => import("./pages/SubjectPage"));
const FlashSalePage      = themedLazy(() => import("./pages/FlashSalePage"));
const PolicyPage         = themedLazy(() => import("./pages/PolicyPage"));
const ContactPage        = themedLazy(() => import("./pages/ContactPage"));
const FaqPage            = themedLazy(() => import("./pages/FaqPage"));
const AuthorsPage        = themedLazy(() => import("./pages/AuthorsPage"));
const AuthorPage         = themedLazy(() => import("./pages/AuthorPage"));

const routes = [
  { path: "/",                       element: HomePage },
  { path: "/register",               element: RegisterPage },
  { path: "/login",                  element: LoginPage },
  { path: "/tim-kiem",               element: SearchPage },
  { path: "/danh-muc/:category",     element: SearchPage },
  { path: "/thuong-hieu/:brand",     element: SearchPage },
  { path: "/nuoc-san-xuat/:country", element: SearchPage },
  { path: "/tim-kiem/:keyword",      element: SearchPage },
  { path: "/:category/:url",         element: ProductDetailPage },
  { path: "/gio-hang",               element: CartPage },
  { path: "/flash-sale",             element: FlashSalePage },
  { path: "/bai-viet",               element: NewsPage },
  { path: "/bai-viet/:url",          element: PostPage },
  { path: "/chuyen-muc/:subject",    element: SubjectPage },
  { path: "/checkout",               element: PaymentPage },
  { path: "/account",                element: ProfilePage },
  { path: "/orders",                 element: OrderPage },
  { path: "/trang/:slug",            element: PolicyPage },
  { path: "/lien-he",                element: ContactPage },
  { path: "/cau-hoi-thuong-gap",     element: FaqPage },
  { path: "/tac-gia",                element: AuthorsPage },
  { path: "/tac-gia/:slug",          element: AuthorPage },
  { path: "*",                       element: NotFound },
];

export default routes;
